module.exports = __webpack_public_path__ + "img/empty.b78a2295.png";